import { User } from '@/types/user';
import { ALLOCATION_STATUS, DueDiligenceRecordStatus } from '@trace-8/trace8-schema';
import { Investment } from '../dealCatalog-page/types';
import { ISubscriptionDocument } from '../transactions-page/types';

export interface FetchAllocationComplianceResponse {
  total: number;
  offset: number;
  perPage: number;
  allocations: AllocationComplianceDto[];
}

export interface AllocationComplianceDto {
  id: string;
  statusDate: Date;
  status: keyof typeof ALLOCATION_COMPLIANCE_STATUSES;
  details: string;
  advisoryFirm: AllocationComplianceAdvisoryFirmDto;
  legalEntity: AllocationComplianceLegalEntityDto;
  investment: AllocationComplianceInvestmentDto;
  subscriptionDocuments: Pick<ISubscriptionDocument, 'id'>[];
}

interface AllocationComplianceAdvisoryFirmDto {
  id: string;
  name: string;
  type: string;
}

interface AllocationComplianceLegalEntityDto {
  id: string;
  entityName: string;
  family: AllocationComplianceFamilyDto;
}

interface AllocationComplianceFamilyDto {
  id: string;
  name: string;
}

interface AllocationComplianceInvestmentDto {
  id: string;
  name: string;
}

export interface DueDiligenceComplianceRecordsListResponseDto {
  total: number;
  limit: number;
  offset: number;
  records: DueDiligenceComplianceRecordDto[];
}

export interface DueDiligenceComplianceRecordDto {
  id: string;
  investment: Investment;
  status: keyof typeof DUE_DILIGENCE_COMPLIANCE_TAB_RECORD_STATUSES;
  statusUpdatedAt: Date;
  approver: User;
  activeTier: DueDiligenceFunnelTier;
}

interface DueDiligenceFunnelTier {
  id: string;
  name: string;
  funnel: DueDiligenceFunnel;
}

interface DueDiligenceFunnel {
  id: string;
  name: string;
}

export const ALLOCATION_COMPLIANCE_STATUSES = {
  COMMITTED: ALLOCATION_STATUS.COMMITTED,
  INTERNAL_REVIEW_REJECTED: ALLOCATION_STATUS.INTERNAL_REVIEW_REJECTED,
  TERMINATED: ALLOCATION_STATUS.TERMINATED
} as const;

DueDiligenceRecordStatus;

export const DUE_DILIGENCE_COMPLIANCE_TAB_RECORD_STATUSES = {
  APPROVED: DueDiligenceRecordStatus.APPROVED,
  REJECTED: DueDiligenceRecordStatus.REJECTED
} as const;
